import { data, useLoaderData } from 'react-router';
import { PAGE_QUERY } from '~/api/sanity/queries/Page';
import { ErrorPageTypes } from '~/constants';
import { useRootLoaderData } from '~/hooks/useRootLoaderData';
import { sanityQuery } from '~/lib/sanity/sanity.server';
import { seoPayload } from '~/lib/seo.server';
import type { SanityPageResponse } from '~/types/sanity/page';
import { getSeoMetaSafe } from '~/utils/metaTags';
import { getComponents } from '~/utils/sanity';
import type { Route } from './+types/_cart._index';

export const loader = async ({ context }: Route.LoaderArgs) => {
  const { data: page } = await sanityQuery<SanityPageResponse>({
    query: PAGE_QUERY,
    params: { slug: 'homepage' },
    context,
  });

  if (!page) {
    throw data(ErrorPageTypes.PAGE, 404);
  }

  const seo = seoPayload.home();

  return { page, seo };
};

export const meta: Route.MetaFunction = ({ loaderData }) => {
  return getSeoMetaSafe(loaderData?.seo);
};

export default function Homepage() {
  const { isAuthenticated } = useRootLoaderData();
  const { page } = useLoaderData<typeof loader>();

  const components = page.components;

  return components
    ? getComponents(components, {
        isAuthenticated: !!isAuthenticated,
      })
    : null;
}
